import { render } from "./CategoriaPersonalizacaoEdit.vue?vue&type=template&id=14f8b84a&scoped=true"
import script from "./CategoriaPersonalizacaoEdit.vue?vue&type=script&lang=js"
export * from "./CategoriaPersonalizacaoEdit.vue?vue&type=script&lang=js"

import "./CategoriaPersonalizacaoEdit.vue?vue&type=style&index=0&id=14f8b84a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14f8b84a"

export default script